<template>
  <div class="view">
    <div class="content contentBody">
      <div class="condition">
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item>
              <span class="choosedep"></span>
              <el-button @click="choosedep">选择部门</el-button>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formdata.user" placeholder="请输入员工姓名"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search"></el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="员工姓名"></el-table-column>
          <el-table-column prop="name" label="所属部门"></el-table-column>
          <el-table-column prop="address" label="分享次数"></el-table-column>
          <el-table-column prop="address" label="获客数"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span @click="sharedetail(scope.row)" class="action_btn">分享明细</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination background layout="prev, pager, next" :total="50"></el-pagination>
        </div>
      </div>
    </div>
    <chooseDepDialog
      :visible.sync="choosedepdialog"
      v-if="choosedepdialog"
      @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
  </div>
</template>
<script>
import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
export default {
  name: "MaterialEmployee",
  components: {
    chooseDepDialog
  },
  data() {
    return {
      formdata: {
        user: ""
      },
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ],
      choosedepdialog: false
    };
  },
  methods: {
    // 选择部门
    choosedep() {
      this.choosedepdialog = true;
    },
    choosedepsucess(val) {
      // this.formdata.depart_name = val.name;
      // this.formdata.depart_id = val.id;
    },
    // 分享明细
    sharedetail() {
      this.$router.push({ name: "employeeDetails" });
    }
  }
};
</script>
